import React, { useState, useRef, useEffect } from 'react';

const Tooltip = ({ content, position = 'top', children }) => {
  const [visible, setVisible] = useState(false);
  const ref = useRef(null);
  const hideTimeoutRef = useRef(null);

  const show = () => setVisible(true);
  const hide = () => setVisible(false);

  const handleTouchStart = () => {
    show();
    if (hideTimeoutRef.current) clearTimeout(hideTimeoutRef.current);
    hideTimeoutRef.current = setTimeout(hide, 1500);
  };

  useEffect(() => () => {
    if (hideTimeoutRef.current) clearTimeout(hideTimeoutRef.current);
  }, []);

  const positionClasses = {
    top: 'bottom-full left-1/2 -translate-x-1/2 mb-2',
    bottom: 'top-full left-1/2 -translate-x-1/2 mt-2',
    left: 'right-full top-1/2 -translate-y-1/2 mr-2',
    right: 'left-full top-1/2 -translate-y-1/2 ml-2',
  };

  return (
    <div
      ref={ref}
      className="relative inline-flex"
      onMouseEnter={show}
      onMouseLeave={hide}
      onFocus={show}
      onBlur={hide}
      onTouchStart={handleTouchStart}
    >
      {children}
      {visible && content && (
        <div
          className={`absolute ${positionClasses[position]} z-50 pointer-events-none`}
        >
          <div className="bg-primary-50 text-xs font-medium px-2.5 py-1.5 rounded-lg shadow-lg whitespace-nowrap border-2 border-primary-200 text-primary-700">
            {content}
          </div>
        </div>
      )}
    </div>
  );
};

export default Tooltip;
